import React from 'react';
import { alpha, TableCell, TableCellProps } from '@mui/material';
import { styled } from '@mui/system';

const TableHeadCell = styled(
  TableCell,
  {},
)<{ is_light?: string }>(({ theme, is_light }) => ({
  height: '64px',

  background: is_light
    ? alpha(theme.palette.background.paper, 0.55)
    : `linear-gradient(
        68deg,
        ${alpha(theme.palette.primary.main, 1)},
        ${alpha(theme.palette.primary.dark, 1)}
      )`,

  backdropFilter: 'blur(18px) saturate(180%)',
  WebkitBackdropFilter: 'blur(18px) saturate(180%)',

  color: is_light ? theme.palette.text.primary : theme.palette.common.white,

  fontSize: '15px',
  fontWeight: 700,
  letterSpacing: '0.3px',

  border: `1px solid ${alpha(theme.palette.common.white, 0.18)}`,

  textAlign: 'center',

  boxShadow: `
    inset 0 1px 0 ${alpha(theme.palette.common.white, 0.2)},
    0 4px 12px ${alpha(theme.palette.common.black, 0.06)}
  `,

  transition: 'all 0.25s ease',

  '&:first-of-type': {
    borderTopLeftRadius: '18px',
  },

  '&:last-of-type': {
    borderTopRightRadius: '18px',
  },
}));

const TableRCell = styled(TableCell)(({ theme }) => ({
  padding: '14px 0px',

  background: alpha(theme.palette.background.paper, 0.45),

  backdropFilter: 'blur(14px) saturate(180%)',
  WebkitBackdropFilter: 'blur(14px) saturate(180%)',

  borderBottom: `1px solid ${alpha(theme.palette.common.white, 0.12)}`,

  color: theme.palette.text.primary,

  transition: 'all 0.25s ease',

  '&:hover': {
    background: alpha(theme.palette.primary.main, 0.06),
  },

  '& > .row-container': {
    padding: '16px',

    borderRight: `1px solid ${alpha(theme.palette.common.white, 0.12)}`,

    height: '100%',

    display: 'grid',
    alignItems: 'center',

    transition: 'all 0.25s ease',
  },

  '&:last-of-type > .row-container': {
    borderRight: 'unset !important',
  },
}));

interface TableRowProps extends TableCellProps {
  children: React.ReactNode;
}

const TableRowCell = function (props: TableRowProps) {
  const { children, ...TableCellProps } = props;
  return (
    <TableRCell {...TableCellProps}>
      <div className="row-container">{children}</div>
    </TableRCell>
  );
};

const ShipmentActionsContainer = styled('div')(({ theme }) => ({
  padding: '10px 14px',

  borderRadius: '14px',

  background: alpha(theme.palette.background.paper, 0.45),

  backdropFilter: 'blur(14px)',
  WebkitBackdropFilter: 'blur(14px)',

  border: `1px solid ${alpha(theme.palette.common.white, 0.18)}`,

  boxShadow: `0 4px 16px ${alpha(theme.palette.common.black, 0.05)}`,
}));

export { TableHeadCell, TableRowCell, ShipmentActionsContainer };
